import { UitkCardAloha } from "uitk-react-cards";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "uitk-react-images";
import * as React from "react";
import { PackageCardProps } from "./typings";
import { DefaultCardContents } from "components/flexComponents/Packages/components/DefaultCardContents";

export const PackageCardMobile = ({ packageItem, index, language, isMobile }: PackageCardProps) => (
  <UitkCardAloha className="all-t-margin-three">
    <UitkFigure ratio={UitkFigureAspectRatioType.R21_9}>
      <UitkImage src={packageItem.hotelImageUrl} alt={packageItem.hotelName} placeholderImage={true} />
    </UitkFigure>
    <UitkLayoutPosition type="relative" cloneElement={true}>
      <DefaultCardContents packageItem={packageItem} index={index} language={language} overImage={true} />
    </UitkLayoutPosition>
  </UitkCardAloha>
);
